

export const bindOnChange = (e , variable)=>{
  variable = e.nativeEvent.target.value;
  return variable;
};

export const getValue = (e)=>{
  return e.nativeEvent.target.value;
}